import React from 'react';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { IconSelect, ReactSelectOption } from '@/core/IconSelect.molecule';
import { getFormFieldProps, getFormFieldWrapperProps } from '@/formbuilder/formbuilder.utilities';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import classNames from 'classnames';
import { Icon } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';

export interface IconSelectProps extends ValidatingFormComponent<any> {
  component: 'IconSelectFormComponent';
  selectOptions: ReactSelectOption[];
  onChange: (option: { value: any }, property?: string) => void;
  onBlur?: any;
  formattedOptions?: boolean;
  placeholder?: string;
  testId?: string;
  insideModal?: boolean;
  appendToBody?: boolean;
  disabled?: boolean;
  wrapperClasses?: string;
  isMultipleSelect?: boolean;
  isSearchable?: boolean;
  onRemove?: (option: { value: any }) => void;
  // if true component will not be memoized. this should be used SPARINGLY. Should only be necessary if you need to
  // access state that would be stale if your component is memoized (see PeriodicCondition)
  skipMemo?: boolean;
  onTooltipClick?: () => void;
  creatable?: boolean;
  labelClassNames?: string;
  removeAllEnabled?: boolean;
  onRemoveAllClick?: () => void;
  showAddButton?: boolean;
  onClickAddButton?: () => void;
  addButtonTooltip?: string;
}

export const IconSelectFormComponent: React.FunctionComponent<IconSelectProps> = (props) => {
  const {
    name,
    validation,
    testId = 'iconSelect',
    wrapperClassNames,
    customErrorText,
    labelClassNames,
    showAddButton = false,
    onClickAddButton,
    addButtonTooltip,
  } = props;
  const { t } = useTranslation();

  const defaultValidation = _.isEmpty;
  const formState = useForm().getState();
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    ((formState.modified && formState.modified[name]) || formState.submitFailed);

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['wrapperClassNames', 'testId'])}
      testId={testId}
      labelClassNames={labelClassNames}
      wrapperClassNames={classNames('flexFill', wrapperClassNames)}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={validation || defaultValidation}>
        {({ input, meta }) => (
          <div className={classNames(showAddButton && 'flexColumnContainer flexAlignCenter width-100percent')}>
            <IconSelect
              {...getFormFieldProps(formState, input, meta, props)}
              testId={`${testId}Field`}
              extraClassNames={showAddButton ? 'width-300' : ''}
            />
            {showAddButton && (
              <Icon
                type="theme"
                icon="fa-plus"
                extraClassNames="ml5"
                onClick={onClickAddButton}
                tooltip={addButtonTooltip && t(addButtonTooltip)}
                testId={`${testId}AddButton`}
              />
            )}
          </div>
        )}
      </Field>
    </FormFieldWrapper>
  );
};
